import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api, { apiError } from "../lib/api";

export function EmailCapture({
  source = "site",
  variant = "light",
  heading = "Get the free AI setups",
  sub = "One plain-English setup at a time. No hype, no spam. Unsubscribe anytime.",
  redirectToThankYou = false,
  compact = false,
}) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();
  const onNavy = variant === "navy";

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/subscribe", { email, source });
      toast.success(data.message || "You're in!");
      setDone(true);
      setEmail("");
      if (redirectToThankYou) navigate("/thank-you");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Could not sign you up.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={onNavy ? "on-navy" : ""} data-testid={`email-capture-${source}`}>
      {!compact && (
        <>
          <h3 className={`text-2xl md:text-3xl ${onNavy ? "!text-bone" : ""}`}>{heading}</h3>
          <p className={`mt-2 text-[15px] ${onNavy ? "!text-on-navy-body max-w-none" : "text-text-muted"}`}>{sub}</p>
        </>
      )}
      {done && !redirectToThankYou ? (
        <p className={`mt-4 font-sans font-bold uppercase tracking-[0.12em] ${onNavy ? "text-teal-bright" : "text-teal"}`}>
          ✓ You're on the list — talk soon.
        </p>
      ) : (
        <form onSubmit={submit} className={`mt-4 flex flex-col gap-3 sm:flex-row ${compact ? "mt-0" : ""}`}>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@email.com"
            className="brand-input flex-1"
            data-testid={`email-input-${source}`}
          />
          <button type="submit" className="btn btn-primary whitespace-nowrap" disabled={loading} data-testid={`email-submit-${source}`}>
            {loading ? <Loader2 className="animate-spin" size={16} /> : "Send me setups"}
          </button>
        </form>
      )}
    </div>
  );
}
